import type { PropType } from 'vue';
import type { UploadProps } from 'ant-design-vue';
import type { FormConfig } from '../form/types';

/*
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-04-27 14:54:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-29 09:53:06
 */
export type Api = (params: object, formData: FormData) => Promise<unknown>;

export interface IUpload extends UploadProps, FormConfig {
  hiddenList?: boolean; // 隐藏列表

  api?: Api;

  params?: PropType<object>;

  multiple?: boolean;

  maxSize?: number;

  maxCount?: number;

  accept?: string;

  uploadNow?: boolean; // 立即上传
}

export enum UploadResultStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  UPLOADING = 'uploading',
}

export interface FileItem {
  uid: string;
  name: string;
  size: number;
  type?: string;
  file: File;
  status?: UploadResultStatus;
  percent: number;
}

export class EmbedFileInfo {
  /* 系统唯一文件id */
  id: string | null | undefined = null;

  /* 文件名 */
  fileName: string | null | undefined = null;

  /* 访问路径 */
  path: string | null | undefined = null;

  /* 文件大小 */
  length = 0;
}
